export enum ImageOptions {
    home = 'home',
    about = 'about',
    contact = 'contact',
    service = 'service',
}
